import React, {useState} from "react";
import useIsMounted from "../../../../hooks/use-is-mounted";
import Api from "../../../../../core/services/api/api";
import {defaultNotificationCategory} from "../../../../views/panel/common/notification-management";
import {ReactComponent as BookmarkIcon} from "../../../../../assets/images/notifications/bookmark.svg";
import {Fade, SvgIcon, useTheme} from "@mui/material";
import ButtonDropdown from "../../button-dropdown";
import IconButton from "../../../base/button/icon_button";
import {ReactComponent as Share} from "../../../../../assets/images/share.svg";
import DateUtils from "../../../../../core/services/date-utils";
import Utils from "../../../../../core/services/utils/utils";
import useAccessLevels from "../../../../hooks/use-access-levels";


const removeFromBookmark = {
    id: -2,
    orderIndex: Number.MAX_SAFE_INTEGER,
    title: "Remove from bookmark"
}

const ReceivedNotificationCard = ({
                                      notification,
                                      categories,
                                      updateCategory,
                                      unAuthorizedOrAccessDeniedCallback,
                                  }) => {
    const theme = useTheme();
    const [togglingSavedStatus, setTogglingSavedStatus] = useState(false)
    const isMounted = useIsMounted();
    const {packages} = useAccessLevels();
    const canViewList = packages.notifications.viewList;
    const categoryColor = notification?.userCategory?.colorCode ?? defaultNotificationCategory.colorCode

    /**
     * navigates to biz core main url
     */
    const onNotificationClicked = () => {
        //TODO: navigate to the notification
    }


    /**
     * Un-Saves the notification in the server and in case of success, invokes the unSaveNotificationProps callback.
     */
    const unSaveNotification = (setPopover) => {
        if (!canViewList) return;
        setTogglingSavedStatus(true);
        Api.toggleNotificationSavedStatus(notification.id, unAuthorizedOrAccessDeniedCallback).then((response) => {
            if (!isMounted()) return;
            if (response?.resultFlag) {
                updateCategory(response.data)
                if (setPopover) setPopover(false)
            }
            setTogglingSavedStatus(false)
        })

    }

    /**
     * Updates a notification category in the server.
     *
     * if the notification is not saved, then first saves the category (make it default group)
     * if the selected category is not a default category, then updates the notifications category
     */
    const updateNotificationCategory = async (category, setPopover) => {
        if (!canViewList) return;
        if (category?.id === removeFromBookmark.id) {
            unSaveNotification(setPopover)
            return
        }
        setTogglingSavedStatus(true);
        if (!notification.isSaved) {
            const saveResponse = await Api.toggleNotificationSavedStatus(notification.id)
            if (!isMounted()) return;
            if (!saveResponse?.resultFlag) {
                setTogglingSavedStatus(false);
                return;
            }
        }
        const forApi = {
            notificationId: notification.id,
            categoryId: category?.id === defaultNotificationCategory.id ? null : category.id,
        }
        const response = await Api.setCategoryForNotification(forApi)
        if (!isMounted()) return
        if (!response?.resultFlag) {
            setTogglingSavedStatus(false);
            return;
        }
        updateCategory({
            ...notification,
            isSaved: true,
            userCategory: category?.id === defaultNotificationCategory.id ? null : category,
        })
        setTogglingSavedStatus(false);
        if (setPopover) setPopover(false)
    }


    return (
        <div className={'received-notification-card'}>
            <div className={'d-flex w-100'}>
                <Fade className={'img sharp'} in={!!notification?.senderApplication}>
                    <img
                        src={Utils.encodeFileUrl(notification?.senderApplication?.logoUrl)}
                        alt={notification?.senderApplication?.name}
                    />
                </Fade>
                <div
                    className={'d-flex flex-column flex-grow-1 ml-2'}>
                    <div className={'d-flex align-items-center justify-content-between'}>
                        <p className='title'>
                            {notification.title ?? ''}
                            <span>
                                {
                                    notification.submitDateTime
                                        ? DateUtils.serverToLocal(notification.submitDateTime).fromNow()
                                        : ''
                                }
                            </span>
                        </p>
                        {
                            !notification.isSaved
                                ? <IconButton
                                    onPressed={() => updateNotificationCategory(defaultNotificationCategory)}
                                    color={'secondary'}
                                >
                                    <SvgIcon className={'icon normal'} component={BookmarkIcon}/>
                                </IconButton>
                                : <ButtonDropdown
                                    arrowPlacement={'right'}
                                    title={togglingSavedStatus
                                        ? "submitting..."
                                        : notification.userCategory?.title ?? defaultNotificationCategory.title
                                    }
                                    options={[...(categories ?? []), removeFromBookmark]
                                        .filter(e => e.id !== (notification.userCategory?.id ?? defaultNotificationCategory.id))
                                        .map(e => ({
                                            ...e,
                                            id: e.id,
                                            title: e.title,
                                            disabled: togglingSavedStatus,
                                        }))}
                                    buttonProps={{
                                        style: notification.userCategory
                                            ? {
                                                '--color': categoryColor,
                                                background: 'transparent',
                                                border: `1px solid ${categoryColor}`,
                                            }
                                            : {
                                                '--color': theme.palette.text.primary,
                                                background: theme.palette.background.paper,
                                                border: `1px solid ${theme.palette.text.primary}`,
                                            },
                                    }}
                                    popoverProps={{
                                        classes: {
                                            paper: "notification-button-dropdown-popover"
                                        },
                                    }}
                                    onOptionSelected={updateNotificationCategory}
                                />
                        }
                    </div>

                    <div className='d-flex w-100 justify-content-start align-items-center no-padding mb-3'>
                        <p className='body'>
                            {notification.body ?? ''}
                        </p>
                    </div>
                    <div className={'d-flex justify-content-end'}>
                        <IconButton
                            onPressed={onNotificationClicked}
                            color={'secondary'}
                        >
                            <SvgIcon component={Share} className={'icon normal'}/>
                        </IconButton>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default ReceivedNotificationCard;
